import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,CalculatorFilled,SwapOutlined,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled } from '@ant-design/icons';
import moment from 'moment';
import { Line,Pie,Bar } from 'react-chartjs-2';
import {withGetScreen} from 'react-getscreen'
import { Tooltip,Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import * as serverconfig from '../serverconn'
import * as serversocketconfig from '../serversocketconfig'
import { MdShoppingCart } from 'react-icons/md';

import CurrencyFormat from 'react-currency-format';
import Highlighter from 'react-highlight-words';
import Websocket from 'react-websocket';
import { Link } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { NavLink } from 'react-router-dom'
import * as primarycolor from '../primarycolor'
import PortalHome_Banner from './PortalHome_Banner';
import Login from './Login';
import Portal_Registration from './Portal_Registration';
import All_licence_map from './All_licence_map';

var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;


class PortalHome extends React.Component {

  state = {
    userprofile:{},
  };

 
  componentDidMount(){
 
    
  }



render() {
      return(
        <div className="animated fadeIn" style={{width:'100%'}}>  
        <PortalHome_Banner />
        <Divider style={{}}></Divider>

        <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
          <TabPane tab="Home" key="1">
            <h4  aria-level="1">Welcome to Uganda's Mining Cadastre Portal</h4>
             <p >The goal of this Mining Cadastre Portal is to provide an electronic platform for all stakeholders in the mining sector in Uganda to engage directly with the Directorate of Geological Survey and Mines.</p>
          <p >Before using the Mining Cadastre Portal, you must first register for access.</p>
          <p ><strong>Existing mineral rights holders</strong></p>
          <ul>
          <li>
          <div >If you already hold mineral rights, or have a pending application for them, download and complete the Registration Form and submit it, along with supporting documents, to the Directorate in Entebbe.</div>
          </li>
          </ul>
          <p ><strong>Prospective rights applicants</strong></p>
          <ul>
          <li>
          <div >If you don't already hold mineral rights in Uganda, use the Self Registration online form to submit your particulars and supporting documents through the portal.</div>
          </li>
          </ul>
          <p ><strong>To find out more</strong></p>
          <ul>
          <li>
          <div >Click the Registration Details link&nbsp;to find out more about getting access to use the Mining Cadastre Portal.</div>
          </li>
          </ul>
          <p>--------------------------------------------------------------------------------------------------------------------------------------</p>
          <p><strong>Disclaimer:</strong></p>
          <p><strong>The Directorate of Geological Survey and Mines notes that this is a phased implementation, therefore;</strong></p>
          <p>1) DGSM is currently undertaking a data cleaning exercise and thus all data on the e-government portal is to be considered provisional. Assistance with obtaining the correct information and data on your license will be greatly appreciated and a benefit to both DGSM and license holders alike.</p>
          <p>2) Registered users may now</p>
          <ul>
          <li>View license details, contact details and update contact details</li>
          <li>Submit new license applications and license renewal applications</li>
          <li>Make online payments via a payment gateway</li>
          <li>Submit reports</li>
          <li>Perform transfers</li>
          <li>Perform surrenders</li>
          <li>Perform withdrawals</li>
          </ul>
          <p><strong><br />The Directorate of Geological Survey and Mines noted the following on submitted license areas:&nbsp;</strong></p>
          <p>&nbsp;1) Exclusion areas are allowed in your license area but if you submit 2 or more different areas please note that only one will be considered at the discretion of the commissioner.</p>
               


          </TabPane>

          <TabPane tab="Sign In" key="2">
            <Login/>

          </TabPane>

          <TabPane tab="Registration" key="3">
            <Portal_Registration />
          </TabPane>

          <TabPane tab="Map" key="4">
            <All_licence_map />
          </TabPane>


          </Tabs>

          
        </div>
      )
}
}

export default PortalHome; 
